import React, { useState } from "react";
import { PhoneIcon, MailIcon } from "@heroicons/react/outline";
import { InView } from "react-intersection-observer";
import Swal from "sweetalert2";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    requestPoster: false,
  });

  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("http://194.164.148.244:4061/api/users/contactwithus", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Thank You!",
          text: data.message || "Your message has been sent. We'll get back to you shortly.",
          confirmButtonColor: "#8B5CF6",
          background: "#1f2937",
          color: "#f3f4f6",
        });

        setFormData({
          name: "",
          email: "",
          message: "",
          requestPoster: false,
        });

        setErrorMessage("");
      } else {
        throw new Error(data.message || "Something went wrong!");
      }
    } catch (error) {
      console.error("Submission Error:", error);
      setErrorMessage(error.message);
    }
  };

  return (
    <div className="bg-gray-950 py-20">
      <div className="container mx-auto px-6 flex flex-col lg:flex-row items-start gap-12">
        {/* Left Section - Contact Info */}
        <InView triggerOnce={true} threshold={0.5}>
          {({ inView, ref }) => (
            <div
              ref={ref}
              className={`w-full lg:w-2/5 text-left ${
                inView ? "animate__animated animate__fadeInLeft" : "opacity-0"
              }`}
            >
              <h2 className="text-4xl sm:text-5xl font-bold mb-6">
                <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                  Quick Support
                </span>
              </h2>
              <p className="text-xl text-gray-300 mb-8 font-semibold">
                Get in touch with us!
              </p>
              
              <div className="space-y-8">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-purple-600 to-pink-600 flex items-center justify-center flex-shrink-0">
                    <PhoneIcon className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <p className="text-gray-400 text-sm">Call Us</p>
                    <p className="text-xl text-white font-semibold">+91 9182971816 </p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-purple-600 to-pink-600 flex items-center justify-center flex-shrink-0">
                    <MailIcon className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <p className="text-gray-400 text-sm">Email Us</p>
                    <p className="text-lg text-white">editezy.contact@gmail.com</p>
                    <p className="text-gray-400 mt-1">Available from 9 AM to 5 PM</p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </InView>

        {/* Right Section - Contact Form */}
        <InView triggerOnce={true} threshold={0.5}>
          {({ inView, ref }) => (
            <div
              ref={ref}
              className={`w-full lg:w-3/5 bg-gray-900 rounded-2xl p-8 border border-gray-800 shadow-2xl ${
                inView ? "animate__animated animate__fadeInRight" : "opacity-0"
              }`}
            >
              <h2 className="text-2xl font-bold text-white mb-8">
                Fill out the form, and we'll get back to you as soon as possible.
              </h2>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label className="block text-gray-300 font-semibold mb-2">Your Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full p-3 bg-gray-800 border border-gray-700 rounded-xl text-white focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20 transition-all"
                    placeholder="Enter your name"
                    required
                  />
                </div>
                <div>
                  <label className="block text-gray-300 font-semibold mb-2">Your Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full p-3 bg-gray-800 border border-gray-700 rounded-xl text-white focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20 transition-all"
                    placeholder="Enter your email"
                    required
                  />
                </div>
                <div>
                  <label className="block text-gray-300 font-semibold mb-2">Message</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="4"
                    className="w-full p-3 bg-gray-800 border border-gray-700 rounded-xl text-white focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20 transition-all resize-none"
                    placeholder="How can we help you?"
                    required
                  />
                </div>
                <div className="flex items-center gap-3">
                  <input
                    type="checkbox"
                    name="requestPoster"
                    checked={formData.requestPoster}
                    onChange={handleChange}
                    className="w-5 h-5 rounded border-gray-700 text-purple-600 focus:ring-purple-500"
                  />
                  <span className="text-gray-300">
                    Yes, I would like to request a poster.
                  </span>
                </div>
                {errorMessage && (
                  <p className="text-red-400 bg-red-900/20 p-3 rounded-xl">{errorMessage}</p>
                )}
                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold py-4 px-6 rounded-xl hover:from-purple-700 hover:to-pink-700 transition-all duration-300 transform hover:scale-[1.02] shadow-lg shadow-purple-500/25"
                >
                  Send Message
                </button>
              </form>
            </div>
          )}
        </InView>
      </div>
    </div>
  );
};

export default ContactUs;